import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/offer';
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-28" data-mp="gwx6p6t7jdfu">
      <Reveal className="mx-auto max-w-3xl" data-id="element-29" data-mp="vsmm2m3w0sbl">
        <div className="mb-12 text-center" data-id="element-30" data-mp="vuh7e1j2mmg7">
          <div className="inline-flex rounded-full bg-brand-green/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-green" data-id="element-31" data-mp="qtt6mo51ir8s">
            INCLUDED FREE TODAY
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-32" data-mp="14r82obpstx9q">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-33" data-mp="1eje0i22qf8wu">
            Worth <span className="font-bold text-brand-green line-through" data-id="element-34" data-mp="1eiujcnkwoojv">$195 USD</span> — yours to unlock today.
          </p>
        </div>
        <div className="space-y-3" data-id="element-35" data-mp="19mnd0tollb1e">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-deep/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-36" data-mp="1nhzh3ron8duz" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-deep font-serif font-bold text-white" data-id="element-37" data-mp="3ps51cves7pb8">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-38" data-mp="2kb00xqv4wra" />
              <div className="min-w-0 flex-1" data-id="element-39" data-mp="gl58fgdwuxpy">
                <h3 className="font-bold leading-snug text-brand-deep" data-id="element-40" data-mp="gju8jrnl6a44">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-41" data-mp="ldew0prjzlp2">
                  <span className="text-brand-gray" data-id="element-42" data-mp="qb6yuetqks81">{bonus.description}</span>
                  <span className="ml-2 inline-flex rounded-full bg-brand-green/10 px-2 py-0.5 font-extrabold text-brand-green" data-id="element-43" data-mp="qdb0sr82rh5o">
                    VALUE {bonus.price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-amber" data-id="element-44" data-mp="109mjbyy9d38k">FREE</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}